import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Entity } from 'app/pages/product/product.model';
import { BehaviorSubject, of } from 'rxjs';
import { debounceTime, startWith, switchMap } from 'rxjs/operators';
import {MatSelectionList} from '@angular/material/list';

@Component({
  selector: 'entity-list',
  templateUrl: './entity-list.component.html',
  styleUrls: ['./entity-list.component.scss']
})
export class EntityListComponent implements OnInit, OnChanges {

    constructor() { }
    public id: number;

    @Input('values')
    entities: Entity[];

    @Input()
    title: string;

    @ViewChild('entityList')
    entityList: MatSelectionList;

    @Output()
    entitySelected: EventEmitter<any> = new EventEmitter();

    public search = new FormControl();

    // Create a BehaviorSubject to track changes to the entities array
    private entitiesSubject = new BehaviorSubject<Entity[]>([]);

    $search = this.search.valueChanges.pipe(
        startWith(null),
        debounceTime(200),
        switchMap((res: string) => {
          // Get the current value of the entities array from the BehaviorSubject
          const currentEntities = this.entitiesSubject.getValue();
          if (!res) {
            return of(currentEntities);
          }
          res = res.toLowerCase();
          return of(
            currentEntities.filter(x => this.getNameFunction(x).toLowerCase().indexOf(res) >= 0)
          );
        })
      );


    @Input()
    getNameFunction: (entity: any) => string = (entity: any) => entity.name

    ngOnInit(): void {
        // Initialize the entitiesSubject with the initial value of the entities array
        if (this.entities) {
            this.entitiesSubject.next(this.entities);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        // Update the entitiesSubject when the entities array changes
        if (changes.entities && this.entities) {
            this.entitiesSubject.next(this.entities);
        }
    }

    deselectAll(): void{
        // No usamos MatSelectionList, así que reseteamos el ID seleccionado
        this.id = null;
    }

    selected(entity: Entity): void{
        this.entitySelected.emit(entity);
        this.id = entity.id;
    }

}
